module.exports = __webpack_public_path__ + "static/media/time_morning.0a5a0f6d.svg";